export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://salesmanconnect.com").replace(/\/$/, "");
export const SITE_NAME = "Salesman Connect";
export const LINKEDIN_PERSONAL = "https://www.linkedin.com/in/salesmanconnect/";
export const LINKEDIN_COMPANY = "https://www.linkedin.com/company/salesmanconnect/";
export const DEFAULT_DESC =
  "Salesman Connect is the skills-first talent platform connecting home-improvement companies (bath & shower remodeling, roofing, solar, HVAC, windows, siding, gutters and more) with elite one-call-close, in-home sales closers. Hire top closers or find high-paying in-home sales jobs near you.";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/favicon-512.png`,
  description: DEFAULT_DESC,
  sameAs: [LINKEDIN_COMPANY],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: "alex@salesmanconnect.com",
    areaServed: "US",
    availableLanguage: "English",
  },
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/jobs?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

// Founder brand / ad video (streamed from CDN, referenced not bundled).
export const BRAND_VIDEO = "https://customer-assets-39nsmqrw.emergentagent.net/job_fb31e197-dcfd-4d95-a6bc-5c57886d5caa/artifacts/37zarao5_SC%20AD.mp4";
export const BRAND_VIDEO_POSTER = "https://static.prod-images.emergentagent.com/jobs/fb31e197-dcfd-4d95-a6bc-5c57886d5caa/images/14e76a72d5f169c0d93600c65c957b442ed22c8e9decf0814455cf0b816227a0.jpeg";
export const videoObjectJsonLd = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  name: "Salesman Connect, The #1 Platform for In-Home Sales Closers",
  description: DEFAULT_DESC,
  thumbnailUrl: [BRAND_VIDEO_POSTER],
  uploadDate: "2026-06-23",
  duration: "PT43S",
  width: 1920,
  height: 1080,
  contentUrl: BRAND_VIDEO,
  embedUrl: `${SITE_URL}/`,
  publisher: { "@type": "Organization", name: SITE_NAME, logo: { "@type": "ImageObject", url: `${SITE_URL}/favicon-512.png` } },
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: SITE_URL + it.path,
  })),
});
